import * as Const from '@/helpers/constants';

export const AREA_COUNTERS_TILES = {
  campaignOverview: {
    id: 'campaign-overview',
    link: `${Const.getAbsoluteRoute(Const.ROUTES.CR_OVERVIEW)}?filter=allRequests`,
    title: 'dashboard.campaignRequestOverview',
    subtitle: 'feedback.total',
    icon: 'di icon-datei-doppelt-kopieren',
    chipKey: 'allRequests',
  },
  createNewCr: {
    id: 'create-new-cr',
    title: 'welcome.newRequest',
    icon: 'di icon-plus-hinzufuegen-klein',
  },
  myOpenRequests: {
    id: 'my-open-requests',
    link: `${Const.getAbsoluteRoute(Const.ROUTES.CR_OVERVIEW)}?filter=myOpenRequests`,
    title: 'campaignRequests.myOpenRequests',
    icon: 'di icon-datei-text',
    chipKey: 'myOpenRequests',
  },
  administration: {
    id: 'administration',
    title: 'dashboard.administration',
    icon: 'di icon-computer-laptop',
  },
  requestsToApprove: {
    id: 'requests-to-approve',
    link: `${Const.getAbsoluteRoute(Const.ROUTES.CR_OVERVIEW)}?filter=requestsToApprove`,
    title: 'dashboard.requestsToApprove',
    icon: 'di icon-datei-text',
    chipKey: 'requestsToApprove',
  },
  notAssignedToMe: {
    id: 'applications-not-assigned-CR',
    link: `${Const.getAbsoluteRoute(Const.ROUTES.CR_OVERVIEW)}?filter=notAssigned`,
    title: 'dashboard.applicationsSubmitted',
    icon: 'di icon-datei-suche',
    chipKey: 'notAssigned',
  },
  assignedToMe: {
    id: 'applications-assigned-CR',
    link: `${Const.getAbsoluteRoute(Const.ROUTES.CR_OVERVIEW)}?filter=assignedToMe`,
    title: 'dashboard.applicationsAssigned',
    icon: 'di icon-datei-check-bearbeiten',
    chipKey: 'assignedToMe',
  },
  subCampaignOverview: {
    id: 'sub-campaign-overview',
    link: Const.getAbsoluteRoute(Const.ROUTES.CR_OVERVIEW),
    title: 'dashboard.campaignRequestOverview',
    icon: 'di icon-datei-doppelt-kopieren',
    chipKey: 'allRequestsSubCr',
  },
  requestsCoordinationToPlantApproval: {
    id: 'coordination-to-plant-approval',
    link: `${Const.getAbsoluteRoute(Const.ROUTES.CR_OVERVIEW)}?filter=coordinationToPlantApproval`,
    title: 'dashboard.coordinationToPlantApproval',
    icon: 'di icon-datei-doppelt-kopieren',
    chipKey: 'coordinationToPlantApproval',
  },
  requestsToAcknowledge: {
    id: 'requests-to-acknowledge',
    link: `${Const.getAbsoluteRoute(Const.ROUTES.CR_OVERVIEW)}?filter=requestsToAcknowledge`,
    title: 'dashboard.requestsToAcknowledge',
    icon: 'di icon-datei-doppelt-kopieren',
    chipKey: 'requestsToAcknowledge',
  },
  requestsToInPlantConsolidation: {
    id: 'request-to-in-plant-consolidation',
    link: `${Const.getAbsoluteRoute(Const.ROUTES.CR_OVERVIEW)}?filter=inPlantConsolidation`,
    title: 'dashboard.requestsToInPlantConsolidation',
    icon: 'di icon-datei-doppelt-kopieren',
    chipKey: 'inPlantConsolidation',
  },
  requestsToApproveSubCr: {
    id: 'subcr-requests-to-approve-van',
    link: `${Const.getAbsoluteRoute(Const.ROUTES.CR_OVERVIEW)}?filter=requestsToApproveSubCr`,
    title: 'dashboard.requestsToApproveSubCR',
    icon: 'di icon-datei-text',
    chipKey: 'requestsToApproveSubCr',
  },
  subCampaignRequestsToApprove: {
    id: 'subcr-requests-to-approve',
    link: `${Const.getAbsoluteRoute(Const.ROUTES.CR_OVERVIEW)}?filter=requestsToApproveSubCr`,
    title: 'dashboard.requestsToApprove',
    icon: 'di icon-datei-text',
    chipKey: 'requestsToApproveSubCr',
  },
  subCampaignRequestsToApproveByQMB: {
    id: 'subcr-requests-to-approve-by-qmb',
    link: `${Const.getAbsoluteRoute(Const.ROUTES.CR_OVERVIEW)}?filter=inPlantApprovalSubCr`,
    title: 'dashboard.decisionNeededByQMB',
    icon: 'di icon-datei-text',
    chipKey: 'inPlantApprovalSubCr',
  },
  applicationsNotAssigned: {
    id: 'applications-not-assigned',
    link: `${Const.getAbsoluteRoute(Const.ROUTES.CR_OVERVIEW)}?filter=notAssignedSubCr`,
    title: 'dashboard.applicationsSubmitted',
    icon: 'di icon-datei-suche',
    chipKey: 'notAssignedSubCr',
  },
  applicationsAssigned: {
    id: 'applications-assigned',
    link: `${Const.getAbsoluteRoute(Const.ROUTES.CR_OVERVIEW)}?filter=assignedToMeSubCr`,
    title: 'dashboard.applicationsAssigned',
    icon: 'di icon-datei-check-bearbeiten',
    chipKey: 'assignedToMeSubCr',
  },
};

export const TASKS_OPTIONS = {
  creatingRequests: 'creatingRequests',
  requestsForChange: 'requestsForChange',
  requestsToApprove: 'requestsToApprove',
  assignedToMe: 'assignedToMe',
  notAssigned: 'notAssigned',
  coordinationToPlantApproval: 'coordinationToPlantApproval',
  // SUBCR
  requestsToApproveSubCr: 'requestsToApproveSubCr',
  assignedToMeSubCr: 'assignedToMeSubCr',
  notAssignedSubCr: 'notAssignedSubCr',
  inPlantApprovalSubCr: 'inPlantApprovalSubCr',
  // VANS
  plantApprovalToPlantPreparation: 'plantApprovalToPlantPreparation',
  inVanPlantCoordination: 'inVanPlantCoordination',
  requestsToAcknowledge: 'requestsToAcknowledge',
};

export const TASKS_INFO = {
  [TASKS_OPTIONS.requestsToApprove]: {
    icon: 'di icon-richterhammer-2',
    title: 'dashboard.yourDecisionNeeded',
    messageTitle: 'recipients.requester',
    rolesCanSee: [Const.APPROVER, Const.APPROVER_JV, Const.VAN_E3_CAUSER,
      Const.VAN_E3_CHIEF_ENGINEER_CARLINE],
    dateMessage: '',
    chipOption: {
      key: 'request-approval-button',
      id: 'request-approval-button',
      btnIco: 'di icon-richterhammer-2',
      btnText: 'dashboard.requestForApproval',
    },
    isSubCr: false,
  },
  [TASKS_OPTIONS.requestsForChange]: {
    icon: 'di icon-pfeil-aktualisieren',
    title: 'dashboard.changesRequested',
    messageTitle: 'dashboard.rework',
    rolesCanSee: [Const.ADMIN, Const.CREATOR, Const.CREATOR_EXTERNAL, Const.CREATOR_JV],
    dateMessage: '',
    chipOption: {
      key: 'request-for-changes',
      id: 'request-for-changes',
      btnIco: 'di icon-pfeil-aktualisieren',
      btnText: 'dashboard.requestForChange',
    },
    isSubCr: false,
  },
  [TASKS_OPTIONS.creatingRequests]: {
    icon: 'di icon-stift-bearbeiten',
    title: 'dashboard.youAreCreatingCr',
    messageTitle: 'dashboard.crCreationInProgress',
    rolesCanSee: [Const.ADMIN, Const.CREATOR, Const.CREATOR_EXTERNAL, Const.CREATOR_JV],
    dateMessage: 'dashboard.lastEdit',
    chipOption: {
      key: 'creating-cr-button',
      id: 'creating-cr-button',
      btnIco: 'di icon-stift-bearbeiten',
      btnText: 'dashboard.creatingCr',
    },
    isSubCr: false,
  },
  [TASKS_OPTIONS.assignedToMe]: {
    icon: 'di icon-richterhammer-2',
    title: 'dashboard.yourDecisionNeeded',
    messageTitle: 'recipients.requester',
    rolesCanSee: [Const.RD_COMMITTEE_COORDINATOR, Const.VAN_COMMITTEE_COORDINATOR],
    dateMessage: '',
    chipOption: {
      key: 'assigned-to-me-button',
      id: 'assigned-to-me-button',
      btnIco: 'di icon-richterhammer-2',
      btnText: 'dashboard.applicationsAssigned',
    },
    isSubCr: false,
  },
  [TASKS_OPTIONS.notAssigned]: {
    icon: 'di icon-richterhammer-2',
    title: 'dashboard.yourDecisionNeeded',
    messageTitle: 'recipients.requester',
    rolesCanSee: [Const.RD_COMMITTEE_COORDINATOR],
    dateMessage: '',
    chipOption: {
      key: 'not-assigned-to-me-button',
      id: 'not-assigned-to-me-button',
      btnIco: 'di icon-richterhammer-2',
      btnText: 'dashboard.applicationsSubmitted',
    },
    isSubCr: false,
  },
  [TASKS_OPTIONS.coordinationToPlantApproval]: {
    icon: 'di icon-richterhammer-2',
    title: 'dashboard.yourDecisionNeeded',
    messageTitle: 'recipients.requester',
    rolesCanSee: [Const.COMMITTEE_COORDINATOR],
    dateMessage: '',
    chipOption: {
      key: 'assigned-to-me-button',
      id: 'assigned-to-me-button',
      btnIco: 'di icon-richterhammer-2',
      btnText: 'dashboard.applicationsAssigned',
    },
    isSubCr: false,
  },
  // SUBCR
  [TASKS_OPTIONS.requestsToApproveSubCr]: {
    icon: 'di icon-richterhammer-2',
    title: 'dashboard.yourDecisionNeeded',
    messageTitle: 'recipients.requester',
    rolesCanSee: [Const.CART_QMB_PLANT_APPROVER, Const.QMB_PLANT_APPROVER_JV, Const.VAN_E3_QMB_PLANT_APPROVER, Const.CART_PLANT_SUPERVISOR],
    dateMessage: '',
    chipOption: {
      key: 'request-approval-button',
      id: 'request-approval-button',
      btnIco: 'di icon-richterhammer-2',
      btnText: 'dashboard.requestForApproval',
    },
    isSubCr: true,
  },
  [TASKS_OPTIONS.assignedToMeSubCr]: {
    icon: 'di icon-richterhammer-2',
    title: 'dashboard.yourDecisionNeeded',
    messageTitle: 'recipients.requester',
    rolesCanSee: [Const.CAMPAIGN_MANAGER, Const.VAN_CAMPAIGN_MANAGER, Const.CAMPAIGN_MANAGER_JV],
    dateMessage: '',
    chipOption: {
      key: 'assigned-to-me-button',
      id: 'assigned-to-me-button',
      btnIco: 'di icon-richterhammer-2',
      btnText: 'dashboard.applicationsAssigned',
    },
    isSubCr: true,
  },
  [TASKS_OPTIONS.notAssignedSubCr]: {
    icon: 'di icon-richterhammer-2',
    title: 'dashboard.yourDecisionNeeded',
    messageTitle: 'recipients.requester',
    rolesCanSee: [Const.CAMPAIGN_MANAGER, Const.VAN_CAMPAIGN_MANAGER, Const.CAMPAIGN_MANAGER_JV],
    dateMessage: '',
    chipOption: {
      key: 'not-assigned-to-me-button',
      id: 'not-assigned-to-me-button',
      btnIco: 'di icon-richterhammer-2',
      btnText: 'dashboard.applicationsSubmitted',
    },
    isSubCr: true,
  },
  [TASKS_OPTIONS.inPlantApprovalSubCr]: {
    icon: 'di icon-richterhammer-2',
    title: 'dashboard.yourDecisionNeeded',
    messageTitle: 'recipients.requester',
    rolesCanSee: [Const.CAMPAIGN_MANAGER, Const.CAMPAIGN_MANAGER_JV],
    dateMessage: '',
    chipOption: {
      key: 'decision-by-qmb-button',
      id: 'decision-by-qmb-button',
      btnIco: 'di icon-richterhammer-2',
      btnText: 'dashboard.decisionNeededByQMB',
    },
    isSubCr: true,
  },

  // VANS
  [TASKS_OPTIONS.requestsToAcknowledge]: {
    icon: 'di icon-richterhammer-2',
    title: 'dashboard.yourDecisionNeeded',
    messageTitle: 'recipients.requester',
    rolesCanSee: [Const.VAN_E2_QMB_APPROVER],
    dateMessage: '',
    chipOption: {
      key: 'requests-to-acknowledge-button',
      id: 'requests-to-acknowledge-button',
      btnIco: 'di icon-richterhammer-2',
      btnText: 'dashboard.requestsToAcknowledge',
    },
    isSubCr: false,
  },
  [TASKS_OPTIONS.plantApprovalToPlantPreparation]: {
    icon: 'di icon-richterhammer-2',
    title: 'dashboard.yourDecisionNeeded',
    messageTitle: 'recipients.requester',
    rolesCanSee: [Const.COMMITTEE_COORDINATOR],
    dateMessage: '',
    chipOption: {
      key: 'request-approval-button',
      id: 'request-approval-button',
      btnIco: 'di icon-richterhammer-2',
      btnText: 'dashboard.requestForApproval',
    },
    isSubCr: true,
  },
  [TASKS_OPTIONS.inVanPlantCoordination]: {
    icon: 'di icon-richterhammer-2',
    title: 'dashboard.yourDecisionNeeded',
    messageTitle: 'recipients.requester',
    rolesCanSee: [Const.VAN_CAMPAIGN_MANAGER],
    dateMessage: '',
    chipOption: {
      key: 'request-approval-button',
      id: 'request-approval-button',
      btnIco: 'di icon-richterhammer-2',
      btnText: 'dashboard.requestForApproval',
    },
    isSubCr: true,
  },
};
